export const en = {
    //Elementos generales 
    "Clic here": "Click here",
    "Edit": "Edit",
    "Preview": "Preview",
    "Saving":"Saving",
    "Cancel": "Cancel",
    "Save": "Save",



    //Login
    "Welcome to React": "Welcome to React and react-i18next",
    "Log In": "Login",
    "Username": 'Username',
    "Password": "Password",

    //Home
    "You can start with":"You can start with:",
    "Get the user manual": "Get the user manual",
    "Welcome title" : "Welcome ",
    "Continue title": "Continue where you left off",
    "Continue where you left off": "Return to your learning from your last lesson seen.",
    "Advances": "My Advances",
    "My Advances": "See your learning progress, your time on the platform, and your last lesson viewed.",
    "Diagnostic title": "Diagnostic examination",
    "Diagnostic examination": "Test your knowledge of Excel and Power BI and get a diagnosis to know which topics to reinforce before taking your courses.",
    "Learning title": "Learning routes",
    "Learning routes": "Create personalized playlists with topics from our course catalog that interest you the most.",
    "Entertainment title": "Entertainment room",
    "Entertainment room": "Enter to the entertainment room and relax for a moment before continuing with your learning.",
    "Consulting title" :"Consulting agenda", 
    "Consulting agenda": "Do you need help with Microsoft Office? Schedule a consultation with one of our specialists and we will gladly support you",
    "Pomodoro title" :"Pomodoro technique",
    "Pomodoro Technique": "Maximize your concentration with this time management technique that will help you organize the time you dedicate to your learning.",

    //Queda pendiente, falta traducir primero la app.
    // "Download Click+ Mobile": "Manage your progress, request your statement, and enjoy optimized lessons so you can enjoy them wherever you go. No additional cost.",
    
    "Admin title": "Admin panel",
    "Admin Panel": "Manage platform content.",
    "Just for you": "Just for you",
    "You might be interested": "You might be interested",
    "MOS title": "MOS Certificate",
    "MOS description" : "Prepare for your Microsoft Office Specialist Certificate It will help you improve your data analysis, decision making and process optimization, in addition to standing out for better positions and job opportunities.",
    "Material seen in training": "Material seen in training",
    "See material" : "See material",

    //Atajos para nuevo ingreso
    "Diagnostic test":"Diagnostic test",
    "Diagnostic description":"Test your knowledge of Excel and Power BI and get a diagnosis to know which topics to reinforce before taking your courses.",
    "Learning paths": "Lerning paths",
    "Learning description": "Create personalized playlists with topics from our course catalog that interest you.",


    
    //Listado de cursos

    //Descripcion de las categorias
    "About": "What is the category about?",
    "Aprende a utilizar herramientas que agilizan el uso de la computadora como comandos y atajos de Windows, o sobre el uso del Navegador Web con Internet": "Learn how to use tools that speed up computer use such as Windows commands and shortcuts or how to use the web browser with the internet",
    "Aprende sobre edición de imágenes con la Paquetería Adobe": "Learn about image editin with Adobe Photoshop",
    "Utiliza la Paquetería Office que te ayudarán a realizar tus trabajos de manera eficiente": "Learn how to use Microsft Office to do your work efficiently",
    "Analiza y procesa tus datos de ventas y mejorar tus procesos con Power Business Intelligence": "Analyze and process your sales data and improve your processes with Power Bussiness Intelligence",
    "Obtendrás conocimientos en las herramientas más utilizadas en Home Office como Microsoft Teams, Hangouts o Zoom": "You will gain Knowledge of the most used tools in home office such as Microsoft Teams or zoom",
    "Aprende programación por bloques con Scratch o a hacer carritos de compra en línea en minutos con Wordpress": "Learn block programming with Scrath or make online shopping carts in minutes with Wordpress",
    "Conoce conceptos básicos de la Programación Neurolingüística y aprende cómo utilizarlos": "Lear basic concepts of neurolinguistic programming and learn how to use them.",
    "Adquiere conocimientos básicos y avanzados en el idioma Inglés": "Acquire basic and advanced knowledge of english language",
    "Adquiere conocimientos en las herramientas necesarias para crear tu tienda en línea": "Gain Knowledge of the necesary tools to create your own e-commerce",
    //Categorias de la plataforma
    "Informática": "Computer science",
    "Diseño": "Design",
    "Ofimática": "Office Automation",
    "Inteligencia de Negocios": "Bussiness Intelligence",
    "Home Office": "Home Office",
    "Programación": "Programming",
    "Desarrollo personal": "Personal Development",
    "Idiomas": "Languages",
    "E-commerce": "E-commerce",
    //TODO: Falta complementar las categorias con las de los intereses


    //Cursos de la plataforma
    "Internet": "Internet",
    "Windows 10": "Windows 10",
    "Photoshop": "Photoshop",
    "Excel Aplicado" : "Applied Excel",
    "Excel Intermedio": "Excel Intermediate",
    "Excel Básico": "Basic Excel",
    "Outlook": "Outlook",
    "PowerPoint": "PowerPoint",
    "Word": "Word",
    "Power BI": "Power BI",
    "Power BI Avanzado": "Advanced Power BI",
    "Microsoft Teams": "Microsoft Teams",
    "Zoom": "Zoom",
    "Programación por bloques con Scratch": "Block programming with Scratch",
    "Comunicación Efectiva": "Effective communication",
    "Liderazgo": "Leadership",
    "Resiliencia": "Resilience",
    "Ética profesional": "Professional ethics",
    "Programación Neurolingüística": "Neurolinguistic programming",
    "Programación Neurolingüística para ventas": "Neurolinguistic programming for sales",
    "Resolución de conflictos": "Conflic resolution",
    "English Beginning":"English Beginning",
    "English Intermediate": "English Intermediate",
    "English High Intermediate":"English High Intermediate",
    "Canva Pro": "Canva Pro",
    "Canva": "Canva",
    "Meta Suite Bussiness": "Meta Bussiness Suite",
    "WordPress": "WordPress",

    "Courses you will find here":"Courses you will find here",

     //Navbar
     "Display menu": "Display menu",
     "Search by categories, courses, sections, lessons, learning paths, quick tips, or help forum topics": "Search by categories, courses, sections, lessons, learning paths, quick tips, or help forum topics",
     "Without notifications":"Without notifications",

     "Pomodoro technique":"Pomodoro technique",
     "Settings": "Settings",
     "Notifications": "Notifications",
     "Add second user": "Add second user",
     "Change user": "Change user",
     "Change password": "Change password",
     "Change username": "Change username",
     "Log out": "Log out",

     //Configuracion
    "Settings title": "Configuration",
    "My profile": "My profile",
    "Your account": "Your account",
    "Contract id": "Contract ID",
    "Email": "Email",
    "First name": "Fist name",
    "Last name": "Last name",
    "Phone": "Phone",
    "Username":"Username",
    "Nickname": "Nickname",
    "Profession":"Profession",
    "Your preferences": "Your preferences",
    "No preferences": "You don't have any preferences selected yet",
    "Select preferencies": "Select preferences",
    "Your membership": "Your membership",
    "License": "License",
    "Role": "Role",
    "Registration date": "Registration date",
    "Last login": "Last login", 
    "Expiration date": "Expiration date",
    "Remaining time": "Remaining time",
    "Courses included in my license": "Courses included in my license",

    //Dropzone component
    "dropzone description": "Clic here to upload a photo",

    
    //Sidebar
    "Home":"Home",
    "Home description":"Return to home page",
    "Click+ Misions":"Click+ Quests",
    "Click+ Misions description":"Complete the challenges, earn credits and redeem them for incredible prizes",
    "Quick tips": "Quick Tips",
    "Quick tips description" : "Increase your productivity with the list of keyboard shortcuts that we have to consult, there you will find some of the most important shortcuts for all the Microsoft Office apps and courses from the platform",
    "Help forum notifications": "Foro de Ayuda: Notificaciones Nuevas",
    "Help forum": "Help Forum",
    "Help forum description": "Interact with the Click+ community and share topics, opinions or resolve doubts that arise during your learning with the support of other students",
    "My courses": "My Courses",
    "My courses description": "Enjoy the catalog of courses that we have for you. Complete them all!",
    "AI Suite": "AI Suite",
    "AI Suite description": "Artificial Intelligence increases productivity and quality in your work, explore the different tools powered by AI and unleash their full potencial to use them in all your activities",
    "Bussiness forum": "Bussiness Forum",
    "Bussiness forum description": "Stay in contact with your work team, asign them tasks or activities to increase their potencial, keep track and manage your team by generating multiple reports of the work team progress",
    "Help center": "Help Center",
    "Help center description": "Need help? Consult the FAQ to resolve any questions you may have about the platform and cases related with your Click+ license",
    "My payments description": "Request your account status or renew your Click+ license",
    "MOS preparatory course": "MOS Preparatory Course",
    "MOS preparatory course description": "Prepare yourself and watch what you will need previous your certification exam. When you feel ready you can schedule the date to do the certification exam",

    "dashboardFAQ": {
    "breadcrumb": {
      "title": "Frequently Asked Questions"
    },
    "pageTitle": "Frequently Asked Questions",
    "navigation": {
      "platform": "Platform Usage",
      "groups": "Business Groups",
      "certifications": "Certifications",
      "consulting": "Personalized Consulting",
      "others": "Others"
    },
    "sections": {
      "platform": {
        "q1": {
          "question": "How do I register my second user?",
          "answer": "If you are the holder of a <strong>Click+ Premium</strong> license, you will find the registration form in the upper right corner by clicking on your name in the <strong>\"Register 2nd user\"</strong> option. Upon completion, your colleague will receive a confirmation email and you must share your access credentials with them. Remember that access information is shared, however, within the account you will find a profile for you and your second user."
        },
        "q2": {
          "question": "Where do I start?",
          "answer": {
            "p1": "Take a learning path, which has a list of lessons that will help you develop a specific office software skill.",
            "p2": "Evaluate your knowledge in Excel and Power BI, with a diagnostic exam. Upon completion, you will receive feedback with the Excel/Power BI level you are at and a series of lessons that will help you improve your skills.",
            "p3": "Start the course of your interest. On the main page you will find a list of study categories, which are made up of the best office software courses that will help you in your professional growth."
          }
        },
        "q3": {
          "question": "Where do I start?",
          "answer": {
            "p1": "Begin your learning by clicking on the My Courses section in the side navigation bar or by selecting one of the courses available to you from the home page, select a category and then one of the courses that category has for you.",
            "p2": "Once you start your course, you will record your progress and can view it in the My Progress section, also located in the side navigation bar of your platform.",
            "p3": "With this, you are ready to start your learning in Click+."
          }
        },
        "q4": {
          "question": "What topics does the diagnostic exam cover?",
          "answer": "Excel and Power Business Intelligence (Power BI), upon completion you will receive feedback with suggested lessons according to your knowledge level, to reinforce and learn new skills."
        },
        "q5": {
          "question": "Material seen in training",
          "answer": "If something was not clear, here you will find the support lessons used in your business training taught by an instructor."
        },
        "q6": {
          "question": "What is a learning path?",
          "answer": "It is a playlist of lessons ordered according to the level of knowledge you need to acquire a specific office software skill."
        },
        "q7": {
          "question": "What are quick tips?",
          "answer": "They are shortcuts/commands from different programs that will help you become increasingly agile in handling office software applications."
        },
        "q8": {
          "question": "How do I use the Help Forum?",
          "answer": "You can add a post, where you write any question related to the topics covered in the different courses. An expert and the community in general will answer your question in order to achieve collective knowledge and interaction among students."
        },
        "q9": {
          "question": "How do I position myself in the Ranking of a course?",
          "answer": "At the end of the final evaluation of each course, your grade will be recorded and according to your result you will be positioned in the Ranking, the higher it is, the better."
        },
        "q10": {
          "question": "How do I mark a lesson as completed?",
          "answer": "Each lesson has a checkbox that you can mark when completed, when you feel ready to move on to the next lesson, so you will have better control at your own pace."
        },
        "q11": {
          "question": "How can I know my overall progress?",
          "answer": "On the main page you will find a direct access (bar chart icon) or you can enter from the side menu option \"My progress\"."
        },
        "q12": {
          "question": "How do I change my password?",
          "answer": "In the user drop-down menu, choose \"My profile\" and select the \"Change password\" tab, you will receive a verification code in your email that you must insert to confirm your identity."
        },
        "q13": {
          "question": "Can I view the lessons from my mobile device?",
          "answer": "Yes, activities can be viewed on any device, however, we recommend working on a desktop device, so you can put your knowledge into practice using the necessary commands."
        }
      },
      "groups": {
        "q1": {
          "question": "How can I add a new member to my group?",
          "answer": "To register a member to your business group, you must go to Business Forum > Collaborators and click on the 'New collaborator' button. Once registered, the new member of your team will be able to access the platform with their previously assigned username and password."
        },
        "q2": {
          "question": "What is the business forum for?",
          "answer": "It is an exclusive space for a business group, in which all members of a group view personalized content, created based on the needs and requests of the company, and in the case of the Advisor (Account Holder) can see the individual progress of each member."
        },
        "q3": {
          "question": "What is a business lesson?",
          "answer": "It is a fully customized interactive lesson, aimed at your group of collaborators, which serves as a training syllabus for your company. You can request them in the Business Group > Lessons section."
        },
        "q4": {
          "question": "What is a business publication?",
          "answer": "Unlike the business lesson, a publication is a brief note that the advisor can make, consisting of a description and an auxiliary template that the collaborators of a group can view and download. It is useful for internal informational purposes of the company."
        }
      },
      "certifications": {
        "q1": {
          "question": "How do I get my course completion certificate?",
          "answer": "At the end of the lessons of each course you will find a final exam, which must be passed with a minimum grade of 85%, if you meet this condition, then you can issue your certificate automatically."
        },
        "q2": {
          "question": "What do I need to obtain my MOS certification?",
          "answer": "Review the exclusive section of the MOS Preparatory Course, there you will find all the information in detail to be able to acquire your certification backed by Microsoft."
        }
      },
      "consulting": {
        "q1": {
          "question": "How do I request personalized consulting?",
          "answer": {
            "p1": "Schedule a personalized consultation to resolve any questions related to Office topics, practices or personal projects.",
            "p2": "Request it through the Consulting Schedule Module available from your Click+ platform."
          }
        }
      },
      "others": {
        "q1": {
          "question": "Didn't find an answer?",
          "answer": {
            "line1": "Contact one of our advisors through the online chat, you can find the blue button in the lower right corner.",
            "line2": "Office phone: 477 390 83 01, ext. 101 or 102",
            "line3": "Hours: Monday to Friday: 8:30 a.m. to 8:00 p.m. and Saturdays: 8:00 a.m. to 2:00 p.m"
          }
        }
      }
    }
  },

  "cursoPropedeutico": {
    "breadcrumb": {
      "title": "Preparatory Course"
    },
    "pageTitle": "MOS Preparatory Course",
    "tabs": {
      "propedeutico": "Preparatory Course",
      "info": "MOS Certification",
      "certificaciones": "Acquired Certifications"
    },
    "tour": {
      "step1": "Welcome to the MOS preparatory section. Here we provide a practice environment to prepare you for your MOS certification exam.",
      "step2": "On your left, you will find lessons and exercises along with downloadable files to help you better track your progress.",
      "step3": "Interactive lessons will be displayed here.",
      "step4": "It's time to practice, don't wait any longer. Good luck!"
    },
    "timeline": {
      "manual": {
        "title": "Simulator Manual",
        "description": "As a first step to schedule your exam, we will prepare you in a simulation environment, where you will have 4 attempts to practice and feel confident before taking the official certification exam. You can download the manual below.",
        "button": "Download PDF"
      },
      "process": {
        "title": "Exam Process",
        "description": "After accessing the simulation environment, it is necessary to follow the process below to register for the certification exam.",
        "button": "Download PDF"
      },
      "certiport": {
        "title": "Certiport Account",
        "description1": "You need to have an active Certiport account since the certification exam will be taken there once you complete these steps and schedule your appointment.",
        "description2": "If you don't have an account yet, click the link below to create one.",
        "alert1": "Fill in all fields in the registration form except the 'Student Number' field.",
        "alert2": "Once you schedule your certification exam, we will contact you via WhatsApp to provide your access codes.",
        "button": "Create account"
      },
      "schedule": {
        "title": "Schedule Exam",
        "description": "This is the final and most important step. You need to schedule your certification exam with us by clicking the button and filling out the form.",
        "success": "You have everything needed to schedule your exam",
        "error": "You do not yet meet the requirements to schedule",
        "advisorError": "You do not yet meet the requirements, but you can schedule an exam for one of your collaborators",
        "noMos": "You must have your MOS Certification contracted to schedule your exam.",
        "button": "Schedule"
      }
    },
    "modals": {
      "noCertifications": {
        "title": "You have no MOS Certifications assigned",
        "description": "Assign one from the \"Acquired Certifications\" tab",
        "confirm": "Got it"
      },
      "scheduleExam": {
        "title": "Schedule exam"
      }
    },
    "notifications": {
      "purchaseSuccess": "Purchase completed successfully. You can now assign and schedule a MOS certification exam"
    }
  },
"cursoPropedeuticoMos": {
    "tooltips": {
      "tour": "Explore your environment",
      "play": "Play",
      "fullscreen": "Fullscreen"
    },
    "sections": {
      "lessons": "Support Lessons",
      "projects": "Projects"
    },
    "buttons": {
      "downloadMaterial": "Download support material"
    },
    "emptyState": {
      "title": "Select a lesson or project to start"
    }
  },
  "leccionesMOS": {
    "MOSSRC01": "Accessibility",
    "MOSSRC02": "Add a data series",
    "MOSSRC03": "Apply number formatting",
    "MOSSRC04": "COUNTIF",
    "MOSSRC05": "Configure table style options",
    "MOSSRC06": "Insert total row",
    "MOSSRC07": "Inspect workbook for compatibility issues",
    "MOSSRC08": "LEFT, RIGHT and MID formulas",
    "MOSSRC09": "Pivot tables",
    "MOSSRC10": "Modify shape properties",
    "MOSSRC11": "Hide and show columns",
    "MOSSRC12": "Concatenate",
    "MOSSRC13": "Sort multiple columns",
    "MOSSRC14": "SUMIF",
    "MOSSRC15": "Insert references",
    "MOSSRC16": "Inspect properties",
    "MOSSRC17": "Insert sparklines",
    "MOSSRC18": "Modify document properties",
    "MOSSRC19": "Organize data by multiple columns",
    "MOSSRC20": "Alternative text",
    "MOSSRC21": "Insert text box and shapes",
    "MOSSRC22": "Zoom"
  },
  "proyectosMOS": {
    "MOS16P01": "FERRETERIAMEX: Organize, update and format the workbook",
    "MOS16P02": "HOUSEHOLD EXPENSES: Market study",
    "MOS16P03": "TORNILLOS DURAMAX: Apply formulas and formatting to listings",
    "MOS16P04": "BANCO DEL NORTE: Analyze and create formulas. Add information for customer clarifications",
    "MOS16P05": "SPORTSWEAR: Perform sales analysis and graphical representation",
    "MOS16P06": "MULTIPLAZA COMPANY: Incident report across different areas (adding formatting)",
    "MOS16P07": "EMPLOYEE PAYROLL: Fix errors and apply formatting"
  }


}